import { css } from '@emotion/react';
import { useQuery, useTracks } from 'imddata';
import { AlertBox } from 'imdui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

export const TrackMasteringReloader = ({
  query: passedQuery,
}: {
  query: any;
}) => {
  const { query, queryHash } = useQuery({ query: passedQuery });
  const { reload } = useTracks({ query, queryHash });
  const isMasteringSuccessRoute = useRouteMatch(
    '/library/tracks/mastering-success'
  );

  const { t } = useTranslation();

  useEffect(() => {
    if (isMasteringSuccessRoute) {
      const intervalId = setInterval(reload, 5000); // Refresh every 5 seconds
      return () => clearInterval(intervalId); // Cleanup on unmount
    }
  }, [isMasteringSuccessRoute, reload]);

  if (isMasteringSuccessRoute) {
    return (
      <div
        css={css`
          margin: 24px 24px 0 24px;
          border-bottom: 1px solid var(--outline-var);
          padding-bottom: 24px;
        `}
      >
        <AlertBox
          css={css``}
          type={AlertBox.Type.success}
          title={t('mastering-tracks-will-appear-shortly-title')}
          text={t('mastering-tracks-will-appear-shortly-message')}
        />
      </div>
    );
  }

  return null;
};
